export default {
  name: 'RegenTemplatesListExpand',
  props: {
    data: Object
  },
  data () {
    return {
      items: [],
      loading: true
    }
  },
  computed: {
    tableHeaders () {
      const headers = [
        { key: 'updated_at', label: this.$t('log.created'), type: 'datetime' },
        { key: 'user.name', label: this.$t('user.name') },
        { key: 'status_id', label: this.$t('scheduled-task.status'), format: 'formatFromConfig', configKey: 'scheduled_task_statuses', configParam: 'name' },
        { key: 'callfunc', label: this.$t('scheduled-task.callfunc') },
        { key: 'params', label: this.$t('scheduled-task.params') },
        { key: 'info', label: this.$t('scheduled-task.info') }
      ];
      return headers;
    }
  },
  methods: {
    getTableData () {
      this.loading = true;
      const self = this;
      this.ApiRequest.request('regen-templates/' + this.data.id + '/queue-get', this.ApiRequest.REQUEST_GET, [], function (response) {
        if (response.data) {
          self.items = response.data;
        }
        self.loading = false;
      });
    }
  },
  mounted () {
    this.getTableData();
  }
}
